import { updateKeyInStore } from 'App';
import { updateKey } from '../slice';

import { fields } from '../fields';

type UploadFields = typeof fields;

export const uploadFields: UploadFields = [
  {
    name: 'pleaseUploadTheBusinessRegistrationDocumentFromTheNonUSCountry',
    label:
      'Please upload the business registration document from the non-US country',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'uploadDocumentShowingProofOfIncome',
    label: 'Upload document showing proof of income',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    dependenciesTitle: 'Expenses',
    name: 'ifYouHaveAnOrganizedbyCategoryExcelSheetWithExpensesPleaseUpload',
    label:
      'If you have an organized (by category) excel sheet with expenses, please upload',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    predicate: (value) => value === 'yes',
    dependentOn:
      'taxQuestionnaire.income.selfEmployment.values.doYouWantToListYourBusinessExpenses',
  },
];
